import { Component } from "@mzw/component";

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
	requiredRefs = ["videoSources", "videoElement"];
	#intersectionObserver;

	constructor() {
		super();

		this.#intersectionObserver = new IntersectionObserver(this.handleIntersection, {
			threshold: 0.1,
		});
	}

	connectedCallback() {
		super.connectedCallback();

		this.#intersectionObserver.observe(this);
	}

	disconnectedCallback() {
		super.disconnectedCallback();

		this.#intersectionObserver.unobserve(this);
	}

	handleIntersection = (entries) => {
		const entry = entries[0];
		if (entry.isIntersecting) {
			const { videoSources, videoElement } = this.refs;

			for (const source of videoSources) {
				const { videoSource } = source.dataset;

				if (videoSource) source.setAttribute("src", videoSource);
			}

			videoElement.load();
			this.#intersectionObserver.unobserve(this);
		}
	};
}

if (!customElements.get("video-background-component")) {
	customElements.define("video-background-component", VideoBackgroundComponent);
}
